import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import AuthLayout from "./AuthLayout";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      setResult((await api.post("/auth/forgot-password", { email })).data);
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <AuthLayout title="Reset password" subtitle="Enter your account email to get a reset link.">
      <form onSubmit={submit} className="space-y-5">
        <div><Label htmlFor="email">Email</Label><Input id="email" type="email" required className="mt-1.5 h-11" data-testid="forgot-email-input" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
        {error && <p className="text-sm text-destructive">{error}</p>}
        <Button type="submit" className="w-full h-11" data-testid="forgot-submit-button">Send reset link</Button>
        {result && (
          <div className="rounded-lg border bg-card p-4 text-sm" data-testid="forgot-result">
            <p>{result.message}</p>
            {result.reset_path && (
              <p className="mt-2 text-muted-foreground">
                <span className="font-mono text-[10px] uppercase tracking-wider text-amber-600">Demo mode — email is mocked:</span>{" "}
                <Link to={result.reset_path} className="text-primary underline" data-testid="mock-reset-link">Open reset link</Link>
              </p>
            )}
          </div>
        )}
        <p className="text-sm text-center"><Link to="/login" className="text-primary hover:underline">Back to sign in</Link></p>
      </form>
    </AuthLayout>
  );
}
